import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ChatbotComponent],
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule, RouterModule],
  exports: [ChatbotComponent],
})
export class ChatbotModule {}
